// e.g.: "Head", "Body", "Beard", "Right Sleeve", ...
export interface IAvatarAssetLayerPosition {
    id: string;
    title: string;
    categoryId: string; // IAssetCategory->id
    zIndex: number;
}
